const Bar = ( ( window, undefined ) => {

    var npInterval;

    const _privateMethod = function () {
    };

    const init = function () {

        NProgress.configure({ showSpinner: false });
        NProgress.start();

    };

    const move = function (interval) {

        npInterval = setInterval((function() {
            NProgress.inc();
        }), interval);

    };

    const set = function (percentage) {

        NProgress.inc(percentage);

    };

    const stop = function (interval) {

        setTimeout((function () {
            clearInterval(npInterval);
            NProgress.done();
        }), interval);


    };

    return {
        init: init,
        move: move,
        set: set,
        stop: stop
    };

})( window );